// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  padding: 0;
  background: #E6E8EA;
}

.menu-container {
  display: flex;
  height: 94.25vh;
  width: 100%;
}

.menu-container .findme-btn {
  position: absolute;
  right: 5px;
  top: 135px;
  z-index: 3;
}

.menu-container .findme-close {
  position: absolute;
  right: 5px;
  top: 135px;
  z-index: 3;
}

.menu-container .form-container {
  height: 100%;
  width: 21.92%;
  background-color: "#E6E8EA";
  font-family: "Kanit";
  transition: all 0.3s;
}

.menu-container .form-container .ninety-nine {
  padding-left: 22px;
  display: flex;
  width: 90%;
}

.menu-container .header-form {
  height: 100px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.menu-container .header-form h1 {
  font-family: "Kanit";
  color: #0077b6;
  font-size: 40px;
  font-weight: 1000;
}

.menu-container .form-toggle {
  display: flex;
  justify-content: center;
  align-items: center;
}

.menu-container form label {
  font-size: 22px;
  padding-left: 35px;
}

.date-field {
  height: 40px;
  margin: auto;
  display: block;
  width: 90%;
  font-size: 25px;

  border-radius: 5px;
  color: #6f6f6f;
}

.menu-container form input {
  height: 15px;
  margin: auto;
  display: block;
  width: 80%;
  font-size: 25px;
  padding-left: 20px;
  border-radius: 5px;
  color: #6f6f6f;
}

.menu-container form .dropdown-field {
  height: 50px;
  width: 90%;
  color: #6f6f6f;
  margin-left: 20px;
  padding-left: 20px;
  font-size: 25px;
}

.menu-container form .other-field {
  height: 50px;
  width: 90%;
  color: #6f6f6f;
}

.dropdown {
  position: relative;
  display: inline-block;
  height: 50px;
  width: 90%;
  color: #6f6f6f;
  margin-left: 20px;
}

.menu-container form .dropdown .dropdown-input {
  height: 50px;
  width: 100%;
  color: #6f6f6f;
}

.dropdown-content {
  display: none;
  position: absolute;
  background-color: #f1f1f1;
  width: 100%;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  z-index: 1;
  padding-top: 10px;
}

.dropdown:hover .dropdown-content {
  display: block;
}

.dropdown:hover .dropdown-content h4:hover {
  display: block;
  background-color: "red";
  color: "red";
}

.menu-container form .form-space {
  height: 25px;
  width: 100%;
}

.menu-container .clear-button {
  margin: auto;
  display: block;

  width: 80%;
  height: 44px;
  background-image: linear-gradient(97.41deg, #a50104 0%, #ff792b 100%);
  border-radius: 10px;
  color: white;
  font-size: 20px;
  font-weight: 400;
  cursor: pointer;
}

.menu-container .clear-button:hover {
  margin: auto;
  display: block;
  width: 80%;
  height: 44px;
  background-image: linear-gradient(97.41deg, #ff792b, #a50104);
  border-radius: 10px;
  color: white;
  cursor: pointer;
}

.menu-container .send-button {
  margin: auto;
  display: block;

  width: 80%;
  height: 44px;
  background-image: linear-gradient(97.41deg, #023e8a, #0096c7);
  border-radius: 10px;
  color: white;
  font-size: 20px;
  font-weight: 400;
  cursor: pointer;
}

.menu-container .send-button:hover {
  margin: auto;
  display: block;
  width: 80%;
  height: 44px;
  background-image: linear-gradient(97.41deg, #0096c7, #023e8a);
  border-radius: 10px;
  color: white;
  cursor: pointer;
}

.map {
  height: 100%;
  width: 100%;
}

.menu-container .form-container .toggleContainer {
  position: relative;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  width: 85%;
  border: 3px solid #343434;
  border-radius: 10px;
  background: #ffffff;
  font-weight: bold;
  color: #343434;
  cursor: pointer;
}

.menu-container .form-container .toggleContainer::before {
  content: "";
  position: absolute;
  width: 50%;
  height: 100%;
  left: 0%;
  border-radius: 1px;
  background-image: linear-gradient(92.88deg,
      #023e8a 0%,
      #0077b6 100%,
      #0165a8 100%);
  transition: all 0.3s;
}

.menu-container .form-container .toggleCheckbox:checked+.toggleContainer::before {
  left: 50%;
}

.menu-container .form-container .toggleContainer div {
  padding: 6px;
  text-align: center;
  z-index: 1;
}

.menu-container .form-container .toggleCheckbox {
  display: none;
}

.menu-container .form-container .toggleCheckbox:checked+.toggleContainer div:first-child {
  color: black;
  transition: color 0.3s;
}

.menu-container .form-container .toggleCheckbox:checked+.toggleContainer div:last-child {
  color: #ffffff;
  transition: color 0.3s;
}

.menu-container .form-container .toggleCheckbox+.toggleContainer div:first-child {
  color: white;
  transition: color 0.3s;
}

.menu-container .form-container .toggleCheckbox+.toggleContainer div:last-child {
  color: black;
  transition: color 0.3s;
}

.menu-container .map .toggleContainer {
  position: relative;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  width: 85%;
  border-left: 3px solid #343434;
  border-right: 3px solid #343434;
  border-bottom-right-radius: 10px;
  border-bottom-left-radius: 10px;
  background: #ffffff;
  font-weight: bold;
  color: #343434;
  cursor: pointer;
}

.menu-container .toggleContainer::before {
  content: "";
  position: absolute;
  width: 25%;
  height: 15%;
  left: 12.5%;
  bottom: 0%;
  border-radius: 1px;
  background-image: linear-gradient(92.88deg,
      #023e8a 0%,
      #0077b6 100%,
      #0165a8 100%);
  transition: all 0.3s;
}

.menu-container .toggleCheckbox:checked+.toggleContainer::before {
  left: 62.5%;
}

.menu-container .toggleContainer div {
  padding: 5px;
  text-align: center;
  z-index: 1;
}

.menu-container .toggleCheckbox {
  display: none;
}

.menu-container .toggleCheckbox:checked+.toggleContainer div:first-child {
  color: black;
  transition: color 0.3s;
  border-right: 1px solid #343434;
}

.menu-container .toggleCheckbox:checked+.toggleContainer div:last-child {
  color: #000000;
  transition: color 0.3s;
  border-left: 1px solid #343434;
}

.menu-container .toggleCheckbox+.toggleContainer div:first-child {
  color: rgb(0, 0, 0);
  transition: color 0.3s;
  border-right: 1px solid #343434;
}

.menu-container .toggleCheckbox+.toggleContainer div:last-child {
  color: black;
  transition: color 0.3s;
  border-left: 1px solid #343434;
}

.selection-Date label {
  margin-left: 10px;
}

.date-field-agency input {
  width: 310px;
  height: 40px;
  padding: 16px 14px;
  font-size: 18px;
  border: "5px solid black",

}
div.modal-body-grid3 {
  display: grid;
  grid-template-columns: repeat(3, 35% 17% 40%);
  grid-gap: 1px 10px;
}

div.modal-body-grid2 {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 1px 10px;
}

div.modal-body-grid .grid-item {
  padding: 0px;
  text-align: start;
}

button.modal-footer30 {
  display: block;
  height: 50px;
  width: 30%;
  margin: auto;
  font-weight: bold;
  font-size: 20px;
  color: white;
  border-radius: 10px;
  opacity: 0.85;
}
div.modal-horizontal-line{
  width: 100%;
  height: 2px;
  background-color: black;
  margin: 10px 0px;
}

.btn-deniend {
  background-image: linear-gradient(97.41deg, #a50104 0%, #ff792b 100%);
}
.btn-confirm {
  background-image: linear-gradient(97.41deg, #023E8A, #0096C7);
}

.modal-footer30:hover {
  transition: 0.5s;
  opacity: 1; 
}

@media screen and (max-width: 1300px) {
  .menu-container .form-container {
    height: 100%;
    width: 1300000px;
    background-color: "#E6E8EA";
    font-family: "Kanit";
  }

  .menu-container .findme-btn {
    position: absolute;
    right: 5px;
    top: 135px;
  }

  .menu-container .findme-close {
    width: 0px;
    height: 0px;
    display: none;
  }

  .menu-container .form-container .ninety-nine {
    padding-left: 22px;
    display: flex;
    width: 0%;
  }

  .menu-container .map .toggleContainer {
    position: relative;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    width: 150%;
    border-left: 3px solid #343434;
    border-right: 3px solid #343434;
    border-bottom-right-radius: 10px;
    border-bottom-left-radius: 10px;
    background: #ffffff;
    font-weight: bold;
    color: #343434;
    cursor: pointer;
  }
}

@media screen and (max-width: 575px) {
  .menu-container .header h1 {
    font-family: "Kanit";
    color: #0077b6;
    font-size: 25px;
    font-weight: 1000;
  }
}`, "",{"version":3,"sources":["webpack://./src/Components/agency/AgencyPolygonCreation.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,2BAA2B;EAC3B,oBAAoB;EACpB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,cAAc;EACd,UAAU;EACV,eAAe;;EAEf,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,cAAc;EACd,UAAU;EACV,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,YAAY;EACZ,UAAU;EACV,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;EACX,+CAA+C;EAC/C,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,cAAc;;EAEd,UAAU;EACV,YAAY;EACZ,qEAAqE;EACrE,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,UAAU;EACV,YAAY;EACZ,6DAA6D;EAC7D,mBAAmB;EACnB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,cAAc;;EAEd,UAAU;EACV,YAAY;EACZ,6DAA6D;EAC7D,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,UAAU;EACV,YAAY;EACZ,6DAA6D;EAC7D,mBAAmB;EACnB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,qCAAqC;EACrC,UAAU;EACV,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,QAAQ;EACR,kBAAkB;EAClB;;;mBAGiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,qCAAqC;EACrC,UAAU;EACV,8BAA8B;EAC9B,+BAA+B;EAC/B,gCAAgC;EAChC,+BAA+B;EAC/B,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,WAAW;EACX,UAAU;EACV,kBAAkB;EAClB;;;mBAGiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,+BAA+B;AACjC;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,+BAA+B;AACjC;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf;;AAEF;AACA;EACE,aAAa;EACb,6CAA6C;EAC7C,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,WAAW;EACX,WAAW;EACX,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,qEAAqE;AACvE;AACA;EACE,6DAA6D;AAC/D;;AAEA;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE;IACE,YAAY;IACZ,gBAAgB;IAChB,2BAA2B;IAC3B,oBAAoB;EACtB;;EAEA;IACE,kBAAkB;IAClB,UAAU;IACV,UAAU;EACZ;;EAEA;IACE,UAAU;IACV,WAAW;IACX,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,SAAS;EACX;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,qCAAqC;IACrC,WAAW;IACX,8BAA8B;IAC9B,+BAA+B;IAC/B,gCAAgC;IAChC,+BAA+B;IAC/B,mBAAmB;IACnB,iBAAiB;IACjB,cAAc;IACd,eAAe;EACjB;AACF;;AAEA;EACE;IACE,oBAAoB;IACpB,cAAc;IACd,eAAe;IACf,iBAAiB;EACnB;AACF","sourcesContent":["body {\r\n  margin: 0;\r\n  padding: 0;\r\n  background: #E6E8EA;\r\n}\r\n\r\n.menu-container {\r\n  display: flex;\r\n  height: 94.25vh;\r\n  width: 100%;\r\n}\r\n\r\n.menu-container .findme-btn {\r\n  position: absolute;\r\n  right: 5px;\r\n  top: 135px;\r\n  z-index: 3;\r\n}\r\n\r\n.menu-container .findme-close {\r\n  position: absolute;\r\n  right: 5px;\r\n  top: 135px;\r\n  z-index: 3;\r\n}\r\n\r\n.menu-container .form-container {\r\n  height: 100%;\r\n  width: 21.92%;\r\n  background-color: \"#E6E8EA\";\r\n  font-family: \"Kanit\";\r\n  transition: all 0.3s;\r\n}\r\n\r\n.menu-container .form-container .ninety-nine {\r\n  padding-left: 22px;\r\n  display: flex;\r\n  width: 90%;\r\n}\r\n\r\n.menu-container .header-form {\r\n  height: 100px;\r\n  width: 100%;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n\r\n.menu-container .header-form h1 {\r\n  font-family: \"Kanit\";\r\n  color: #0077b6;\r\n  font-size: 40px;\r\n  font-weight: 1000;\r\n}\r\n\r\n.menu-container .form-toggle {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n\r\n.menu-container form label {\r\n  font-size: 22px;\r\n  padding-left: 35px;\r\n}\r\n\r\n.date-field {\r\n  height: 40px;\r\n  margin: auto;\r\n  display: block;\r\n  width: 90%;\r\n  font-size: 25px;\r\n\r\n  border-radius: 5px;\r\n  color: #6f6f6f;\r\n}\r\n\r\n.menu-container form input {\r\n  height: 15px;\r\n  margin: auto;\r\n  display: block;\r\n  width: 80%;\r\n  font-size: 25px;\r\n  padding-left: 20px;\r\n  border-radius: 5px;\r\n  color: #6f6f6f;\r\n}\r\n\r\n.menu-container form .dropdown-field {\r\n  height: 50px;\r\n  width: 90%;\r\n  color: #6f6f6f;\r\n  margin-left: 20px;\r\n  padding-left: 20px;\r\n  font-size: 25px;\r\n}\r\n\r\n.menu-container form .other-field {\r\n  height: 50px;\r\n  width: 90%;\r\n  color: #6f6f6f;\r\n}\r\n\r\n.dropdown {\r\n  position: relative;\r\n  display: inline-block;\r\n  height: 50px;\r\n  width: 90%;\r\n  color: #6f6f6f;\r\n  margin-left: 20px;\r\n}\r\n\r\n.menu-container form .dropdown .dropdown-input {\r\n  height: 50px;\r\n  width: 100%;\r\n  color: #6f6f6f;\r\n}\r\n\r\n.dropdown-content {\r\n  display: none;\r\n  position: absolute;\r\n  background-color: #f1f1f1;\r\n  width: 100%;\r\n  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);\r\n  z-index: 1;\r\n  padding-top: 10px;\r\n}\r\n\r\n.dropdown:hover .dropdown-content {\r\n  display: block;\r\n}\r\n\r\n.dropdown:hover .dropdown-content h4:hover {\r\n  display: block;\r\n  background-color: \"red\";\r\n  color: \"red\";\r\n}\r\n\r\n.menu-container form .form-space {\r\n  height: 25px;\r\n  width: 100%;\r\n}\r\n\r\n.menu-container .clear-button {\r\n  margin: auto;\r\n  display: block;\r\n\r\n  width: 80%;\r\n  height: 44px;\r\n  background-image: linear-gradient(97.41deg, #a50104 0%, #ff792b 100%);\r\n  border-radius: 10px;\r\n  color: white;\r\n  font-size: 20px;\r\n  font-weight: 400;\r\n  cursor: pointer;\r\n}\r\n\r\n.menu-container .clear-button:hover {\r\n  margin: auto;\r\n  display: block;\r\n  width: 80%;\r\n  height: 44px;\r\n  background-image: linear-gradient(97.41deg, #ff792b, #a50104);\r\n  border-radius: 10px;\r\n  color: white;\r\n  cursor: pointer;\r\n}\r\n\r\n.menu-container .send-button {\r\n  margin: auto;\r\n  display: block;\r\n\r\n  width: 80%;\r\n  height: 44px;\r\n  background-image: linear-gradient(97.41deg, #023e8a, #0096c7);\r\n  border-radius: 10px;\r\n  color: white;\r\n  font-size: 20px;\r\n  font-weight: 400;\r\n  cursor: pointer;\r\n}\r\n\r\n.menu-container .send-button:hover {\r\n  margin: auto;\r\n  display: block;\r\n  width: 80%;\r\n  height: 44px;\r\n  background-image: linear-gradient(97.41deg, #0096c7, #023e8a);\r\n  border-radius: 10px;\r\n  color: white;\r\n  cursor: pointer;\r\n}\r\n\r\n.map {\r\n  height: 100%;\r\n  width: 100%;\r\n}\r\n\r\n.menu-container .form-container .toggleContainer {\r\n  position: relative;\r\n  display: grid;\r\n  grid-template-columns: repeat(2, 1fr);\r\n  width: 85%;\r\n  border: 3px solid #343434;\r\n  border-radius: 10px;\r\n  background: #ffffff;\r\n  font-weight: bold;\r\n  color: #343434;\r\n  cursor: pointer;\r\n}\r\n\r\n.menu-container .form-container .toggleContainer::before {\r\n  content: \"\";\r\n  position: absolute;\r\n  width: 50%;\r\n  height: 100%;\r\n  left: 0%;\r\n  border-radius: 1px;\r\n  background-image: linear-gradient(92.88deg,\r\n      #023e8a 0%,\r\n      #0077b6 100%,\r\n      #0165a8 100%);\r\n  transition: all 0.3s;\r\n}\r\n\r\n.menu-container .form-container .toggleCheckbox:checked+.toggleContainer::before {\r\n  left: 50%;\r\n}\r\n\r\n.menu-container .form-container .toggleContainer div {\r\n  padding: 6px;\r\n  text-align: center;\r\n  z-index: 1;\r\n}\r\n\r\n.menu-container .form-container .toggleCheckbox {\r\n  display: none;\r\n}\r\n\r\n.menu-container .form-container .toggleCheckbox:checked+.toggleContainer div:first-child {\r\n  color: black;\r\n  transition: color 0.3s;\r\n}\r\n\r\n.menu-container .form-container .toggleCheckbox:checked+.toggleContainer div:last-child {\r\n  color: #ffffff;\r\n  transition: color 0.3s;\r\n}\r\n\r\n.menu-container .form-container .toggleCheckbox+.toggleContainer div:first-child {\r\n  color: white;\r\n  transition: color 0.3s;\r\n}\r\n\r\n.menu-container .form-container .toggleCheckbox+.toggleContainer div:last-child {\r\n  color: black;\r\n  transition: color 0.3s;\r\n}\r\n\r\n.menu-container .map .toggleContainer {\r\n  position: relative;\r\n  display: grid;\r\n  grid-template-columns: repeat(2, 1fr);\r\n  width: 85%;\r\n  border-left: 3px solid #343434;\r\n  border-right: 3px solid #343434;\r\n  border-bottom-right-radius: 10px;\r\n  border-bottom-left-radius: 10px;\r\n  background: #ffffff;\r\n  font-weight: bold;\r\n  color: #343434;\r\n  cursor: pointer;\r\n}\r\n\r\n.menu-container .toggleContainer::before {\r\n  content: \"\";\r\n  position: absolute;\r\n  width: 25%;\r\n  height: 15%;\r\n  left: 12.5%;\r\n  bottom: 0%;\r\n  border-radius: 1px;\r\n  background-image: linear-gradient(92.88deg,\r\n      #023e8a 0%,\r\n      #0077b6 100%,\r\n      #0165a8 100%);\r\n  transition: all 0.3s;\r\n}\r\n\r\n.menu-container .toggleCheckbox:checked+.toggleContainer::before {\r\n  left: 62.5%;\r\n}\r\n\r\n.menu-container .toggleContainer div {\r\n  padding: 5px;\r\n  text-align: center;\r\n  z-index: 1;\r\n}\r\n\r\n.menu-container .toggleCheckbox {\r\n  display: none;\r\n}\r\n\r\n.menu-container .toggleCheckbox:checked+.toggleContainer div:first-child {\r\n  color: black;\r\n  transition: color 0.3s;\r\n  border-right: 1px solid #343434;\r\n}\r\n\r\n.menu-container .toggleCheckbox:checked+.toggleContainer div:last-child {\r\n  color: #000000;\r\n  transition: color 0.3s;\r\n  border-left: 1px solid #343434;\r\n}\r\n\r\n.menu-container .toggleCheckbox+.toggleContainer div:first-child {\r\n  color: rgb(0, 0, 0);\r\n  transition: color 0.3s;\r\n  border-right: 1px solid #343434;\r\n}\r\n\r\n.menu-container .toggleCheckbox+.toggleContainer div:last-child {\r\n  color: black;\r\n  transition: color 0.3s;\r\n  border-left: 1px solid #343434;\r\n}\r\n\r\n.selection-Date label {\r\n  margin-left: 10px;\r\n}\r\n\r\n.date-field-agency input {\r\n  width: 310px;\r\n  height: 40px;\r\n  padding: 16px 14px;\r\n  font-size: 18px;\r\n  border: \"5px solid black\",\r\n\r\n}\r\ndiv.modal-body-grid3 {\r\n  display: grid;\r\n  grid-template-columns: repeat(3, 35% 17% 40%);\r\n  grid-gap: 1px 10px;\r\n}\r\n\r\ndiv.modal-body-grid2 {\r\n  display: grid;\r\n  grid-template-columns: repeat(2, 1fr);\r\n  grid-gap: 1px 10px;\r\n}\r\n\r\ndiv.modal-body-grid .grid-item {\r\n  padding: 0px;\r\n  text-align: start;\r\n}\r\n\r\nbutton.modal-footer30 {\r\n  display: block;\r\n  height: 50px;\r\n  width: 30%;\r\n  margin: auto;\r\n  font-weight: bold;\r\n  font-size: 20px;\r\n  color: white;\r\n  border-radius: 10px;\r\n  opacity: 0.85;\r\n}\r\ndiv.modal-horizontal-line{\r\n  width: 100%;\r\n  height: 2px;\r\n  background-color: black;\r\n  margin: 10px 0px;\r\n}\r\n\r\n.btn-deniend {\r\n  background-image: linear-gradient(97.41deg, #a50104 0%, #ff792b 100%);\r\n}\r\n.btn-confirm {\r\n  background-image: linear-gradient(97.41deg, #023E8A, #0096C7);\r\n}\r\n\r\n.modal-footer30:hover {\r\n  transition: 0.5s;\r\n  opacity: 1; \r\n}\r\n\r\n@media screen and (max-width: 1300px) {\r\n  .menu-container .form-container {\r\n    height: 100%;\r\n    width: 1300000px;\r\n    background-color: \"#E6E8EA\";\r\n    font-family: \"Kanit\";\r\n  }\r\n\r\n  .menu-container .findme-btn {\r\n    position: absolute;\r\n    right: 5px;\r\n    top: 135px;\r\n  }\r\n\r\n  .menu-container .findme-close {\r\n    width: 0px;\r\n    height: 0px;\r\n    display: none;\r\n  }\r\n\r\n  .menu-container .form-container .ninety-nine {\r\n    padding-left: 22px;\r\n    display: flex;\r\n    width: 0%;\r\n  }\r\n\r\n  .menu-container .map .toggleContainer {\r\n    position: relative;\r\n    display: grid;\r\n    grid-template-columns: repeat(2, 1fr);\r\n    width: 150%;\r\n    border-left: 3px solid #343434;\r\n    border-right: 3px solid #343434;\r\n    border-bottom-right-radius: 10px;\r\n    border-bottom-left-radius: 10px;\r\n    background: #ffffff;\r\n    font-weight: bold;\r\n    color: #343434;\r\n    cursor: pointer;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 575px) {\r\n  .menu-container .header h1 {\r\n    font-family: \"Kanit\";\r\n    color: #0077b6;\r\n    font-size: 25px;\r\n    font-weight: 1000;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
